module.exports = __webpack_public_path__ + "media/3-1.b74ad403.wav";